import React from "react";
import PropTypes from "prop-types";
import { compose } from "recompose";

// Hooks
import withStyles from "@libs/framework/src/libs/withStyles";

// MUI
import Box from "@material-ui/core/Box";

// MUI Icons
import ChatBubbleOutlineOutlinedIcon from "@material-ui/icons/ChatBubbleOutlineOutlined";

// Config
import { styles } from "./.config";

const FinalPriceInline = compose(withStyles(styles))(({ total, unit }) => {
	const unitTypes = {
		contactForPrice: "Contact for price",
		hourly: "/hour",
		consultation: "/consultation",
	};

	const displayChatBubble = !total;
	const subHeader =
		unit === unitTypes.contactForPrice
			? unit
			: !total
			? unitTypes.contactForPrice
			: "estimated cost";

	return (
		<Box
			display={displayChatBubble ? "flex" : ""}
			alignItems={displayChatBubble ? "center" : ""}
			flexDirection={displayChatBubble ? "row" : ""}
		>
			{displayChatBubble && <ChatBubbleOutlineOutlinedIcon />}
			{!!total && (
				<>
					<Box component={"span"} fontSize={18} fontWeight={600}>
						${total}
					</Box>

					<Box component={"span"} fontSize={14}>
						{" "}
						{unit}
					</Box>
				</>
			)}
			{subHeader && displayChatBubble ? (
				<Box component={"span"} fontSize={14} ml={2} display={"block"}>
					{subHeader}
				</Box>
			) : (
				<Box
					component={"span"}
					fontSize={14}
					ml={2}
					display={{ xs: "none", sm: "block" }}
				>
					{subHeader}
				</Box>
			)}
		</Box>
	);
});

FinalPriceInline.propTypes = {
	unit: PropTypes.string,
	total: PropTypes.number,
};

export default FinalPriceInline;
